module.exports = __webpack_public_path__ + "img/mobile_map_trieste.8b55f558.svg";